import { useState } from 'react';
import {
  Card,
  Container,
  Stack,
  Link,
  Typography,
  TextField,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Button
} from '@mui/material';
import { Icon } from '@iconify/react';
import add from '@iconify/icons-ic/add';
import remove from '@iconify/icons-ic/sharp-minus';
import { Box } from '@mui/system';
import { Link as RouterLink, useParams } from 'react-router-dom';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';

function AddEditChildMaster() {
  const { rowId } = useParams();
  const [masterValue, setMasterValue] = useState([{ masterValue: '' }]);
  const [refreshComp, setRefreshComp] = useState(null);

  const addMoreMasterValue = () => {
    const prevValue = masterValue;
    const obj = { masterValue: '' };
    prevValue.push(obj);
    setMasterValue(prevValue);
    setRefreshComp(new Date());
  };
  const removeMasterValue = (index) => {
    const prevValue = masterValue;
    const removedItem = prevValue.filter((elm, ind) => ind !== index);
    setMasterValue(removedItem);
    setRefreshComp(new Date());
  };
  return (
    <Page title="Kpros by Kalolytic Solutions || Master">
      <Container maxWidth="xl">
        <Box pt={3} pb={3}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <PageTitle info={rowId ? 'Edit master child' : 'Add new Master child'} />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Card>
            <Scrollbar>
              <Box className="fixedBox">
                <Box className="formRowHolder fullrow">
                  <Typography variant="h6" className="formLabel">
                    Master Name
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type master name..."
                  />
                </Box>
                <Box className="formRowHolder fullrow">
                  <Typography variant="h6" className="formLabel">
                    Master Category
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    value=" "
                  >
                    <MenuItem value=" " disabled>
                      Select
                    </MenuItem>
                    <MenuItem> Menu 1</MenuItem>
                    <MenuItem> Menu 1</MenuItem>
                  </Select>
                </Box>
                <Box className="formRowHolder fullrow">
                  <Typography variant="h6" className="formLabel">
                    Master Parent
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    value=" "
                  >
                    <MenuItem value=" " disabled>
                      Select
                    </MenuItem>
                    <MenuItem> Menu 1</MenuItem>
                    <MenuItem> Menu 1</MenuItem>
                  </Select>
                </Box>
                <Box className="formRowHolder fullrow">&nbsp;</Box>
                <Box className="formRowHolder fullrow">
                  <Button variant="contained">Save</Button>
                </Box>
              </Box>
            </Scrollbar>
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
export default AddEditChildMaster;
